export interface IFollowUpComplianceReport {
    centerId: number,
    centerAlias: string,
    
    surveyInstance: number,
    surveyInstanceDescription: string,
    surveyCount: number,
    completeCountLate: number,
    labsCompleteCountLate: number,
    incompleteCount: number,
    labsIncompleteCount: number,
    incompleteCountLate: number,
    labsIncompleteCountLate: number,

    completedCount: number,
    labsCompletedCount: number,

    percentCompletedLate: number,
    labsPercentCompletedLate: number,

    percentCompletedOnTime: number,
    labsPercentCompletedOnTime: number,

    percentIncompleteLate: number,
    labsPercentIncompleteLate: number,

    percentIncompleteOnTime: number,
    labsPercentIncompleteOnTime: number
}